"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcContactQuality = void 0;
const index_1 = require("./index");
function calcContactQuality(epoch) {
    const stds = epoch.data.map((d) => d.filter((i) => !isNaN(i))).map(index_1.standardDeviation);
    // TODO: improve evaluation
    const logs = stds.map((d) => Math.round(Math.log(d)));
    return logs.map((l) => {
        const values = { log: l };
        if (l < 0)
            return Object.assign({ color: 'red', name: 'off' }, values);
        if (l <= 4)
            return Object.assign({ color: 'green', name: 'good' }, values);
        if (l <= 5)
            return Object.assign({ color: 'yellow', name: 'okay' }, values);
        if (l <= 6)
            return Object.assign({ color: 'orange', name: 'poor' }, values);
        return { color: 'red', name: 'bad' };
    });
}
exports.calcContactQuality = calcContactQuality;
//# sourceMappingURL=signal-quality.js.map